import React, { useEffect, useState } from 'react'
import { Box, Container } from '@mui/system'
import Header from '../components/layouts/Header'
import Footer from '../components/layouts/Footer'
import Categories from '../components/modules/Categories';
import axios from 'axios';
import NewItems from '../components/modules/NewItems';

const AppContainer = (props) => {

  const [items, setItems] = useState([]);

  useEffect(() => {
    axios.get("data.json")
    .then(res => res.data)
    .then(data => {
      console.log("Data:", data)
      setItems(data);
    })
    .catch(error => {console.error})
    .finally(() => {});
  }, [])

  return (
    <Box sx={{overflowY: 'hidden',}}>
      <Header items={items} />
      <Container>
        <NewItems items={items.slice(0,4)} />
        <Categories items={items} />
      </Container>
      <Footer />
    </Box>
  )
}

export default AppContainer